import { Department } from "@dune/types";
import { useQuery } from "@tanstack/react-query";
import { privateAxios } from "../axios";

export const getDepartments = async (): Promise<Department[]> => {
	const { data } = await privateAxios.get<Department[]>("/address/departments");
	return data;
};

export const useDepartments = () => {
	return useQuery({
		queryKey: ["departments"],
		queryFn: getDepartments,
	});
};
